var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragandDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2697_19126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 9.43945V18.3537",
    stroke: "#5C5C5C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4262 15.6093C20.3685 15.0643 21.1129 14.2019 21.5419 13.1583C21.9709 12.1146 22.0601 10.9491 21.7954 9.84572C21.5306 8.74232 20.9271 7.76387 20.08 7.06479C19.2328 6.36571 18.1904 5.98581 17.1171 5.98506H15.8998C15.6073 4.78509 15.0623 3.67107 14.3056 2.72674C13.5489 1.78242 12.6002 1.03236 11.531 0.532959C10.4617 0.0335604 9.2996 -0.202183 8.13208 -0.156549C6.96456 -0.110915 5.82198 0.21491 4.79024 0.79643C3.7585 1.37795 2.86446 2.20003 2.17532 3.20087C1.48618 4.20171 1.01987 5.35527 0.811467 6.57481C0.60306 7.79435 0.657971 9.04815 0.972073 10.2419C1.28617 11.4357 1.85129 12.5384 2.62494 13.4672",
    stroke: "#5C5C5C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0858 13.5537L11.3144 9.43945L7.54297 13.5537",
    stroke: "#5C5C5C",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2697_19126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3143,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragandDrop);
export default __webpack_public_path__ + "static/media/DragandDrop.cb1d94b592525a45cd014e0834a4c983.svg";
export { ForwardRef as ReactComponent };